import 'bootstrap/dist/css/bootstrap.css';
import React, { Component } from 'react';
import logo from './images/logo.svg';

class App extends Component {
  render() {
    return (
      <div>
        <div className="fluid-container">
          <nav className="navbar navbar-default">
             <div className="navbar-header">
                <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false">
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
                <a className="navbar-brand">
                  <img alt="Logo" width={"150px"} src={logo}></img>
                </a>
              </div>
              <div className="collapse navbar-collapse" id="navbar-collapse">
                <ul className="nav navbar-nav">
                </ul>
              </div>
          </nav>
        </div>
        <div className="container">
          <h1>In Progress...</h1>
          <p>Please check back again soon.</p>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js